export const ProfileIcon = () => (
  <svg
    className="icon_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="prefix__a" d="M0 0H24V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <path
        fill="#85929E"
        d="M3.937 15.713c6.211-3.418 12.383-3.234 17.983 1.029L24 18.358l-1.895 1.585c-.292.238-.6.477-.923.714-1.658 1.213-3.416 2.146-5.248 2.746l-.388.122c-4.785 1.428-9.352.336-13.537-3.397L0 18.289l2.377-1.63c.498-.332 1.02-.649 1.56-.946zm16.885 2.498c-5.278-4.017-10.752-3.776-16.012-.882-.508.28-.985.57-1.428.866l-.44.302.292.267c3.837 3.424 7.784 4.193 11.794 2.996l.365-.114c1.678-.55 3.267-1.417 4.718-2.48.307-.224.59-.444.846-.654l.122-.101zM12 .6c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm0 1.818c-2.31 0-4.182 1.872-4.182 4.182 0 2.31 1.872 4.182 4.182 4.182 2.31 0 4.182-1.872 4.182-4.182 0-2.31-1.872-4.182-4.182-4.182z"
        mask="url(#prefix__b)"
      />
    </g>
  </svg>
);

export const UserVerificationIcon = () => (
  <svg
    className="icon_2"
    width="23"
    height="23"
    viewBox="0 0 28 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Group 17</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="24" height="24" />
    </defs>
    <g
      id="CIF---Hi-Fi---Old-Brand---Old-UI---desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Five-profiles" transform="translate(-500.000000, -120.000000)">
        <g id="Group-24" transform="translate(220.000000, 108.000000)">
          <g id="Group-22" transform="translate(270.000000, 0.000000)">
            <g id="Group-20">
              <g id="Group-17" transform="translate(10.000000, 12.000000)">
                <g id="icon/1.5px/profile">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="Background" />
                  <path
                    d="M3.937 15.713c3.585-1.973 7.158-2.746 10.614-2.227.656.099.55.726.403 1.78l-.011.077.085.015c-.093 1.416-.093 2.362 0 2.837.17.87.394 1.547.551 2.064l.03.099.116.214c.332.606.76 1.301 1.282 2.087l.2.3c-4.785 1.429-11.014.902-15.198-2.831l-2.009-1.838 2.377-1.63c.498-.332 1.02-.649 1.56-.946zm10.724-.418c-3.19-.502-6.474.176-9.85 2.034-.508.28-.985.57-1.429.866l-.44.302.292.267c3.838 3.424 8.149 3.079 12.16 1.882.483-.159.437-.54.227-1.25l-.011-.042-.005-.009c-.424-.802-.667-1.432-.729-1.892-.162-1.198-.054-2.214.054-2.99l.013-.104zM12 .6c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm0 1.818c-2.31 0-4.182 1.872-4.182 4.182 0 2.31 1.872 4.182 4.182 4.182 2.31 0 4.182-1.872 4.182-4.182 0-2.31-1.872-4.182-4.182-4.182z"
                    fill="#85929E"
                    mask="url(#mask-2)"
                  />
                </g>
                <g
                  id="Group-18"
                  transform="translate(14.000000, 10.000000)"
                  stroke="#85929E"
                  strokeWidth="1.5"
                >
                  <circle id="Oval" cx="7" cy="7" r="6.25" />
                  <path
                    d="M5.931 3.672h2.138v5.49"
                    id="Combined-Shape"
                    strokeLinecap="square"
                    transform="translate(7.000000, 6.416667) scale(1, -1) rotate(-42.000000) translate(-7.000000, -6.416667)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const ContactInfoIcon = () => (
  <svg
    className="icon_3"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      fill="#85929E"
      d="M19.2 1.8c.663 0 1.2.537 1.2 1.2v18c0 .663-.537 1.2-1.2 1.2H4.8c-.663 0-1.2-.537-1.2-1.2V3c0-.663.537-1.2 1.2-1.2h14.4zm-.6 1.8H5.4v16.8h13.2V3.6zm-5.4 11.1c.497 0 .9.403.9.9 0 .456-.339.832-.778.892l-.122.008H8.4c-.497 0-.9-.403-.9-.9 0-.456.339-.832.778-.892L8.4 14.7h4.8zm2.4-3.6c.497 0 .9.403.9.9 0 .456-.339.832-.778.892l-.122.008H8.4c-.497 0-.9-.403-.9-.9 0-.456.339-.832.778-.892L8.4 11.1h7.2zm0-3.6c.497 0 .9.403.9.9 0 .456-.339.832-.778.892L15.6 9.3H8.4c-.497 0-.9-.403-.9-.9 0-.456.339-.832.778-.892L8.4 7.5h7.2z"
    />
  </svg>
);

export const BidDepositIcon = () => (
  <svg
    className="icon_4"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="prefix__a" d="M0 0H24V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <path
        fill="#85929E"
        d="M20.4 3.9c1.823 0 3.3 1.477 3.3 3.3V18c0 1.823-1.477 3.3-3.3 3.3H3.6C1.777 21.3.3 19.823.3 18V7.2c0-1.823 1.477-3.3 3.3-3.3zm1.5 6.6H2.1V18c0 .78.595 1.42 1.356 1.493l.144.007h16.8c.828 0 1.5-.672 1.5-1.5v-7.5zM9.6 15.9c.497 0 .9.403.9.9 0 .456-.339.832-.778.892L9.6 17.7H4.8c-.497 0-.9-.403-.9-.9 0-.456.339-.832.778-.892L4.8 15.9h4.8zm2.4-3.6c.497 0 .9.403.9.9 0 .456-.339.832-.778.892L12 14.1H4.8c-.497 0-.9-.403-.9-.9 0-.456.339-.832.778-.892L4.8 12.3H12zm8.4-6.6H3.6c-.828 0-1.5.672-1.5 1.5v1.5h19.8V7.2c0-.78-.595-1.42-1.356-1.493L20.4 5.7z"
        mask="url(#prefix__b)"
      />
    </g>
  </svg>
);

export const PlaceBidIcon = () => (
  <svg
    className="icon_5"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="prefix__a" d="M0 0H24V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <path
        fill="#85929E"
        d="M14.4 18c1.325 0 2.4 1.075 2.4 2.4v1.2c0 1.325-1.075 2.4-2.4 2.4h-12C1.075 24 0 22.925 0 21.6v-1.2C0 19.075 1.075 18 2.4 18h12zm0 1.8h-12c-.295 0-.54.212-.59.492l-.01.108v1.2c0 .295.212.54.492.59l.108.01h12c.295 0 .54-.212.59-.492L15 21.6v-1.2c0-.295-.212-.54-.492-.59l-.108-.01zm1.027-18.053l3.163 3.164c.933.932.933 2.444 0 3.377l-.111.111c-.802.802-2.032.914-2.953.338l-.367.364 8.256 8.255c.362.362.362.95 0 1.311l-2.177 2.177c-.362.362-.95.362-1.312 0l-8.255-8.255-.368.37.083.143c.485.904.346 2.054-.416 2.817l-.112.112c-.424.424-.967.655-1.522.693l-.166.006c-.611 0-1.222-.233-1.689-.7l-3.18-3.18c-.932-.932-.932-2.444 0-3.376l.112-.112c.802-.802 2.032-.914 2.954-.337L11.593 4.8c-.568-.92-.453-2.143.345-2.941l.112-.112c.932-.932 2.444-.932 3.377 0zm-1.54 8.628l-.942.942 7.637 7.637.942-.943-7.636-7.636zm-8.12.192l-.081.068-.112.112c-.204.204-.227.52-.068.75l.068.08 3.18 3.18c.204.205.52.228.75.069l.081-.068.112-.112c.204-.204.226-.52.068-.75l-.04-.046c-.03-.02-.06-.045-.086-.072l-3.09-3.09c-.027-.026-.05-.055-.07-.084l.038.031c-.204-.204-.521-.227-.75-.068zm7.053-4.45l-4.138 4.138 1.388 1.388 4.138-4.138-1.388-1.388zm.584-3.165l-.081.068-.112.112c-.204.204-.227.52-.068.75l.036.04c.025.02.05.04.073.063l3.09 3.09.065.078.05.041c.2.14.467.14.668 0l.081-.068.112-.111c.204-.204.226-.52.068-.75l-.068-.081-3.164-3.164c-.204-.204-.52-.227-.75-.068z"
        mask="url(#prefix__b)"
      />
    </g>
  </svg>
);

export const BuyerAccordian_icon = () => {
  return (
    <svg
      className="cif-alert-icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="#E2574C"
          d="M11.9,2.7c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C21.3,6.9,17.1,2.7,11.9,2.7L11.9,2.7z M11.9,19.8c-4.2,0-7.7-3.4-7.7-7.7c0-4.2,3.4-7.7,7.7-7.7s7.7,3.4,7.7,7.7C19.5,16.4,16.1,19.8,11.9,19.8L11.9,19.8zM11.9,6.8c-0.7,0-1.2,0.4-1.2,0.9V13c0,0.6,0.5,0.9,1.2,0.9c0.7,0,1.2-0.4,1.2-0.9V7.8C13,7.2,12.5,6.8,11.9,6.8L11.9,6.8zM11.9,15.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2C13,15.6,12.5,15.1,11.9,15.1L11.9,15.1zM11.9,15.1"
        />
      </g>
    </svg>
  );
};
